<template>
  <div>
    <div
      class="kbx-counter"
      klickbox-edit-item="counter"
      :klickbox-edit-label="$t('edit.canvas.progressbar')">
      <span class="kbx-counter-label" :style="getLabelStyle()">1</span>
      <div
        class="kbx-counter-pie"
        klickbox-edit-item-dad="counter"
        klickbox-edit-item="progress-bullet-done"
        :klickbox-edit-label="$t('edit.canvas.active_item')"
        klickbox-edit-not-highlight>
        <div class="left-side half-circle" :style="getDoneStyle()"></div>
        <div class="right-side half-circle" :style="getDoneStyle()"></div>
      </div>
      <div
        class="kbx-counter-shadow"
        klickbox-edit-item-dad="counter"
        klickbox-edit-item="progress-bullet-default"
        :klickbox-edit-label="$t('edit.canvas.default_item')"
        klickbox-edit-not-highlight
        :style="getDefaultStyle()"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  methods: {
    getLabelStyle() {
      const { color } = this.stepStyle('progress-bullet-default');

      return { color };
    },
    getDefaultStyle() {
      const { borderColor } = this.stepStyle('progress-bullet-default');

      return { borderColor };
    },
    getDoneStyle() {
      const { borderColor } = this.stepStyle('progress-bullet-done');

      return { borderColor };
    },
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Counter.vue?b1be612a
 **/